const DEFAULT_TIMEZONE = 'Asia/Karachi';
const MIN_SLOT_DURATION_IN_MINUTES = 15;

export {DEFAULT_TIMEZONE, MIN_SLOT_DURATION_IN_MINUTES};
